var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjInput", {
        staticStyle: { width: "25%" },
        attrs: {
          maxlength: _vm.MAX_LENGTH.DEFAULT,
          placeholder: _vm.$t("billingPage.searchName"),
          clearable: "",
        },
        nativeOn: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.handleQuery.apply(null, arguments)
          },
        },
        model: {
          value: _vm.queryParams.categoryName,
          callback: function ($$v) {
            _vm.$set(_vm.queryParams, "categoryName", $$v)
          },
          expression: "queryParams.categoryName",
        },
      }),
      _c(
        "div",
        { staticStyle: { float: "right" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.handleQuery },
            },
            [_vm._v(_vm._s(_vm.$t("searchText")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "default", plain: "" },
              on: { click: _vm.resetQuery },
            },
            [_vm._v(_vm._s(_vm.$t("resetText")))]
          ),
        ],
        1
      ),
      _vm._l(_vm.tableData, function (item, index) {
        return _c(
          "div",
          { key: index, staticStyle: { "margin-top": "30px" } },
          [
            item && item.group
              ? _c(
                  "div",
                  [
                    _c(
                      "BjDivider",
                      {
                        attrs: { "right-fixed": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "right",
                              fn: function () {
                                return undefined
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_vm._v(_vm._s(item.group) + " ")]
                    ),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.tableData[index].items, border: "" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "billCategoryName",
                            label: _vm.$t("billingPage.serviceType"),
                            width: "180",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: _vm.$t("billingPage.price"),
                            width: "180",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "description",
                            label: _vm.$t("billingPage.description"),
                            align: "center",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }